import React from 'react'

const WhileLoading = () => {
  return (
    <div className='skeleton-loader-background skeleton-loader-gradient'></div>
  )
}

export default WhileLoading